/**
 * useSemantics — семантическое ядро (парсинг semantic-core-corporate.md на бэке).
 */

import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/api/client';

export interface SemPhrase {
  phrase: string;
  freq: string;
  note: string;
}
export interface SemGroup {
  title: string;
  phrases: SemPhrase[];
}
export interface SemCluster {
  title: string;
  groups: SemGroup[];
}
export interface SemanticsResponse {
  clusters: SemCluster[];
  total: number;
}

export function useSemantics() {
  return useQuery<SemanticsResponse>({
    queryKey: ['semantics'],
    queryFn: () => apiFetch<SemanticsResponse>('/api/semantics'),
    staleTime: 5 * 60_000,
  });
}
